import Phaser from 'phaser';
import { loadProfile, saveProfile } from '../game/persistence';
import type { GameState } from '@neon-maw/shared';
import { apiClient } from '../game/apiClient';

export class RewardScene extends Phaser.Scene {
  private finalState!: GameState;
  private sessionId?: string;
  private seed?: number;

  constructor() { super('reward'); }

  init(data: { state: GameState, sessionId?: string, seed?: number }) {
    this.finalState = data.state;
    this.sessionId = data.sessionId;
    this.seed = data.seed;
  }

  create(): void {
    const profile = loadProfile();
    
    this.add.rectangle(0, 0, this.scale.width, this.scale.height, 0x111122).setOrigin(0, 0);
    const cx = this.scale.width / 2;

    const isWin = this.finalState.runStatus === 'won';
    const title = isWin ? 'RUN COMPLETE' : 'RUN OVER';
    const titleColor = isWin ? '#00ff00' : '#ff0000';

    this.add.text(cx, 150, title, {
      fontFamily: 'monospace',
      fontSize: '64px',
      color: titleColor,
      fontStyle: 'bold'
    }).setOrigin(0.5);

    const score = this.finalState.score;
    this.add.text(cx, 250, `Final Score: ${score}`, {
      fontFamily: 'monospace', fontSize: '32px', color: '#fff'
    }).setOrigin(0.5);

    const questsCompleted = this.finalState.quests.filter(q => q.complete).length;
    this.add.text(cx, 300, `Quests Completed: ${questsCompleted} / ${this.finalState.quests.length}`, {
      fontFamily: 'monospace', fontSize: '24px', color: '#88ffee'
    }).setOrigin(0.5);

    this.add.text(cx, 340, `Level Reached: ${this.finalState.biomeId || 'tutorial'}`, {
      fontFamily: 'monospace', fontSize: '24px', color: '#ffaa00'
    }).setOrigin(0.5);

    // Update profile
    if (score > profile.highScore) profile.highScore = score;
    profile.totalScore += score;
    
    // Simple mock unlock logic: every 500 total score unlocks a random new item
    const ITEM_IDS = ['speed_boots', 'shield_gen', 'ghost_cloak', 'power_cell', 'score_coin'];
    let unlockedText = '';
    const itemsToUnlock = ITEM_IDS.filter(i => !profile.unlockedItems.includes(i));
    if (itemsToUnlock.length > 0 && Math.random() < 0.5) {
      const newUnlock = itemsToUnlock[Math.floor(Math.random() * itemsToUnlock.length)];
      profile.unlockedItems.push(newUnlock);
      unlockedText = `UNLOCKED: ${newUnlock}`;
    }

    saveProfile(profile);
    apiClient.syncProfile(profile);

    if (this.sessionId && this.seed) {
      apiClient.finishSession(this.sessionId, score, this.seed);
    }

    if (unlockedText) {
      this.add.text(cx, 400, unlockedText, {
        fontFamily: 'monospace', fontSize: '24px', color: '#ffff00'
      }).setOrigin(0.5);
    }

    const btnReturn = this.add.text(cx, 480, '> RETURN TO HUB <', {
      fontFamily: 'monospace', fontSize: '24px', color: '#ffffff', backgroundColor: '#444444'
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    btnReturn.on('pointerdown', () => {
      this.scene.start('hub');
    });
  }
}
